/* eslint-disable react/require-default-props -- defaults via destructuring; no defaultProps (React 19) */
import React from 'react';
import PropTypes from 'prop-types';

const UPLOAD_ALT_PATH =
  'M9.71 6.70994L11 5.40994V16.9999C11 17.2652 11.1054 17.5195 11.2929 17.707C11.4804 17.8946 11.7348 17.9999 12 17.9999C12.2652 17.9999 12.5196 17.8946 12.7071 17.707C12.8946 17.5195 13 17.2652 13 16.9999V5.40994L14.29 6.70994C14.383 6.80367 14.4936 6.87806 14.6154 6.92883C14.7373 6.9796 14.868 7.00574 15 7.00574C15.132 7.00574 15.2627 6.9796 15.3846 6.92883C15.5064 6.87806 15.617 6.80367 15.71 6.70994C15.8037 6.61698 15.8781 6.50637 15.9289 6.38452C15.9797 6.26266 16.0058 6.13195 16.0058 5.99994C16.0058 5.86793 15.9797 5.73722 15.9289 5.61536C15.8781 5.4935 15.8037 5.3829 15.71 5.28994L12.71 2.28994C12.617 2.19621 12.5064 2.12182 12.3846 2.07105C12.2627 2.02028 12.132 1.99414 12 1.99414C11.868 1.99414 11.7373 2.02028 11.6154 2.07105C11.4936 2.12182 11.383 2.19621 11.29 2.28994L8.29 5.28994C8.1017 5.47824 7.99591 5.73364 7.99591 5.99994C7.99591 6.26624 8.1017 6.52164 8.29 6.70994C8.4783 6.89824 8.7337 7.00403 9 7.00403C9.2663 7.00403 9.5217 6.89824 9.71 6.70994ZM18 8.99994H16C15.7348 8.99994 15.4804 9.1053 15.2929 9.29283C15.1054 9.48037 15 9.73472 15 9.99994C15 10.2652 15.1054 10.5195 15.2929 10.707C15.4804 10.8946 15.7348 10.9999 16 10.9999H18C18.2652 10.9999 18.5196 11.1053 18.7071 11.2928C18.8946 11.4804 19 11.7347 19 11.9999V18.9999C19 19.2652 18.8946 19.5195 18.7071 19.707C18.5196 19.8946 18.2652 19.9999 18 19.9999H6C5.73478 19.9999 5.48043 19.8946 5.29289 19.707C5.10536 19.5195 5 19.2652 5 18.9999V11.9999C5 11.7347 5.10536 11.4804 5.29289 11.2928C5.48043 11.1053 5.73478 10.9999 6 10.9999H8C8.26522 10.9999 8.51957 10.8946 8.70711 10.707C8.89464 10.5195 9 10.2652 9 9.99994C9 9.73472 8.89464 9.48037 8.70711 9.29283C8.51957 9.1053 8.26522 8.99994 8 8.99994H6C5.20435 8.99994 4.44129 9.31601 3.87868 9.87862C3.31607 10.4412 3 11.2043 3 11.9999V18.9999C3 19.7956 3.31607 20.5587 3.87868 21.1213C4.44129 21.6839 5.20435 21.9999 6 21.9999H18C18.7956 21.9999 19.5587 21.6839 20.1213 21.1213C20.6839 20.5587 21 19.7956 21 18.9999V11.9999C21 11.2043 20.6839 10.4412 20.1213 9.87862C19.5587 9.31601 18.7956 8.99994 18 8.99994Z';

const iconPropTypes = {
  size: PropTypes.number,
  className: PropTypes.string,
  'aria-label': PropTypes.string,
  'aria-hidden': PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
};

/**
 * Upload-alt / share export (24×24, u:upload-alt). Arrow up from tray. Color via `currentColor`.
 * Pass `aria-label` when the icon conveys meaning without adjacent text.
 */
const UploadAltIcon = ({
  size = 24,
  fill = 'currentColor',
  className = '',
  'aria-label': ariaLabel,
  'aria-hidden': ariaHidden = true,
  ...props
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={['ds-icon', className].filter(Boolean).join(' ')}
    aria-hidden={ariaLabel ? undefined : ariaHidden}
    aria-label={ariaLabel || undefined}
    role={ariaLabel ? 'img' : undefined}
    focusable="false"
    {...props}
  >
    <path d={UPLOAD_ALT_PATH} fill={fill} />
  </svg>
);

UploadAltIcon.propTypes = {
  ...iconPropTypes,
  fill: PropTypes.string,
};

export { UploadAltIcon };
export default UploadAltIcon;
